export const getStatusFilter = (statusFilter: string[]) => {
  return statusFilter?.length === 1 ? statusFilter[0] : undefined;
};
